// extracted by mini-css-extract-plugin
export default {"icon":"DefaultAppearanceIcon_icon__cY6JV"};